<span class="tooltip-hover tooltip-hover ellipsis">  
    <span pTooltip="{{tooltipText | translate}}" [escape]="false" tooltipPosition="top" title="{{params.value}}">{{params.value}}</span>
</span>

<span *ngIf="tooltipText" class="emptySpan" pTooltip="{{tooltipText | translate}}" [escape]="false" tooltipPosition="top" title="{{params.value}}"></span>